'use strict';

var cov_d1ahqmhf = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/companySizes.js',
        hash = '8e463c52439c0040c38b945c16543d2c55ec3824',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/companySizes.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 26,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 23,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 30
                },
                end: {
                    line: 21,
                    column: 17
                }
            },
            '5': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 26,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'companySizes',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 28
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 24,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_d1ahqmhf.s[0]++;
(function () {
    'use strict';

    cov_d1ahqmhf.f[0]++;
    cov_d1ahqmhf.s[1]++;
    angular.module('app').filter('companySizes', companySizes);

    /* @ngInject */
    function companySizes() {
        cov_d1ahqmhf.f[1]++;
        cov_d1ahqmhf.s[2]++;

        return function (input) {
            cov_d1ahqmhf.f[2]++;
            cov_d1ahqmhf.s[3]++;

            if (input) {
                cov_d1ahqmhf.b[0][0]++;

                var sizes = (cov_d1ahqmhf.s[4]++, {
                    B: '1-10',
                    C: '11-50',
                    D: '51-200',
                    E: '201-500',
                    F: '501-1000',
                    G: '1001-5000',
                    H: '5001-10000',
                    I: '10001+'
                });
                cov_d1ahqmhf.s[5]++;
                return sizes[input];
            } else {
                cov_d1ahqmhf.b[0][1]++;
            }
        };
    }
})();